import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-icon',
  templateUrl: './file-icon.component.html',
  styleUrls: ['./file-icon.component.scss'],
})
export class FileIconComponent implements OnInit {
  @Input() fileType :string|undefined= '';
  fileIcon = '';
  constructor() { }

  ngOnInit(): void {
    this.fileIcon = this.getFileType(this.fileType);
  }
  private getFileType = (fileType?: string) => {
    let fileTypeIcon = '';
    switch (fileType?.toLowerCase()) {
      case '.pdf':
        fileTypeIcon = 'far fa-file-pdf';
        break;
      case '.xls':
      case '.xlsx':
      case '.xlsm':
        fileTypeIcon = 'far fa-file-excel';
        break;
      case '.doc':
      case '.docx':
      case '.docm':
        fileTypeIcon = 'far fa-file-word';
        break;
      case '.bmp':
      case '.gif':
      case '.jpeg':
      case '.png':
      case '.jpg':
        fileTypeIcon = 'far fa-image';
        break;
      case '.mp3':
        fileTypeIcon = 'far fa-file-audio';
        break;
      case '.msg':
        fileTypeIcon = 'far fa-envelope';
        break;
      default:
        fileTypeIcon = 'far fa-file-pdf';
        break;
    }

    return fileTypeIcon;
  };
}
